import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { format } from 'date-fns';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import type { Collect } from '../types';
import { formatTime, resolveCheckValue } from '../utils/formatters';

interface TodayCollectsListProps {
  collects: Collect[];
}

function CollectRow({ collect }: { collect: Collect }) {
  const check = resolveCheckValue(collect);
  const isEntry = check === 'in';
  const label = isEntry ? 'Entrada' : 'Saída';
  const Icon = isEntry ? ArrowDownRight : ArrowUpRight;
  const iconBg = isEntry ? 'bg-green-50' : 'bg-slate-100';
  const iconColor = isEntry ? 'text-green-600' : 'text-slate-500';

  return (
    <div className="flex items-center justify-between py-3">
      <div className="flex items-center gap-3">
        <div className={`flex h-8 w-8 items-center justify-center rounded-lg ${iconBg}`}>
          <Icon className={`h-4 w-4 ${iconColor}`} aria-hidden="true" />
        </div>
        <div>
          <p className="text-sm font-medium text-slate-900">{label}</p>
          <p className="text-[10px] text-slate-500">Localização confirmada</p>
        </div>
      </div>
      <span className="tabular-nums text-sm font-bold text-slate-900">
        {formatTime(collect.time)}
      </span>
    </div>
  );
}

export function TodayCollectsList({ collects }: TodayCollectsListProps) {
  const today = format(new Date(), 'yyyy-MM-dd');
  const todayCollects = collects
    .filter((c) => c.date === today)
    .sort((a, b) => a.time.localeCompare(b.time));

  return (
    <div>
      <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-slate-400">
        Registros de Hoje
      </p>
      <Card>
        <CardContent>
          {todayCollects.length === 0 ? (
            <p className="py-4 text-sm text-slate-400 text-center">Nenhum registro hoje.</p>
          ) : (
            todayCollects.map((c, i) => (
              <div key={c.nsr}>
                {i > 0 && <Separator />}
                <CollectRow collect={c} />
              </div>
            ))
          )}
        </CardContent>
      </Card>
    </div>
  );
}
